(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './korge-root-korge.js', './kotlin-kotlin-stdlib.js', './korge-root-korge-core.js', './korge-root-korge-foundation.js', './korge-root-korlibs-time.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./korge-root-korge.js'), require('./kotlin-kotlin-stdlib.js'), require('./korge-root-korge-core.js'), require('./korge-root-korge-foundation.js'), require('./korge-root-korlibs-time.js'));
  else {
    if (typeof this['korge-root-korge'] === 'undefined') {
      throw new Error("Error loading module 'korgee-korge-virtualcontroller'. Its dependency 'korge-root-korge' was not found. Please, check whether 'korge-root-korge' is loaded prior to 'korgee-korge-virtualcontroller'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'korgee-korge-virtualcontroller'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'korgee-korge-virtualcontroller'.");
    }
    if (typeof this['korge-root-korge-core'] === 'undefined') {
      throw new Error("Error loading module 'korgee-korge-virtualcontroller'. Its dependency 'korge-root-korge-core' was not found. Please, check whether 'korge-root-korge-core' is loaded prior to 'korgee-korge-virtualcontroller'.");
    }
    if (typeof this['korge-root-korge-foundation'] === 'undefined') {
      throw new Error("Error loading module 'korgee-korge-virtualcontroller'. Its dependency 'korge-root-korge-foundation' was not found. Please, check whether 'korge-root-korge-foundation' is loaded prior to 'korgee-korge-virtualcontroller'.");
    }
    if (typeof this['korge-root-korlibs-time'] === 'undefined') {
      throw new Error("Error loading module 'korgee-korge-virtualcontroller'. Its dependency 'korge-root-korlibs-time' was not found. Please, check whether 'korge-root-korlibs-time' is loaded prior to 'korgee-korge-virtualcontroller'.");
    }
    root['korgee-korge-virtualcontroller'] = factory(typeof this['korgee-korge-virtualcontroller'] === 'undefined' ? {} : this['korgee-korge-virtualcontroller'], this['korge-root-korge'], this['kotlin-kotlin-stdlib'], this['korge-root-korge-core'], this['korge-root-korge-foundation'], this['korge-root-korlibs-time']);
  }
}(this, function (_, kotlin_com_soywiz_korge_korge, kotlin_kotlin, kotlin_com_soywiz_korge_korge_core, kotlin_com_soywiz_korge_korge_foundation, kotlin_com_soywiz_korge_korlibs_time) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var GameButton_LX_getInstance = kotlin_com_soywiz_korge_korge.$_$.b;
  var VOID = kotlin_kotlin.$_$.f;
  var protoOf = kotlin_kotlin.$_$.uc;
  var getNumberHashCode = kotlin_kotlin.$_$.rb;
  var THROW_CCE = kotlin_kotlin.$_$.qg;
  var equals = kotlin_kotlin.$_$.lb;
  var classMeta = kotlin_kotlin.$_$.jb;
  var setMetadataFor = kotlin_kotlin.$_$.vc;
  var Unit_instance = kotlin_kotlin.$_$.a5;
  var GamepadInfo = kotlin_com_soywiz_korge_korge.$_$.t;
  var Signal = kotlin_com_soywiz_korge_korge_core.$_$.p3;
  var GameButton_LY_getInstance = kotlin_com_soywiz_korge_korge.$_$.c;
  var Companion_getInstance = kotlin_com_soywiz_korge_korge.$_$.o;
  var listOf = kotlin_kotlin.$_$.i8;
  var Container = kotlin_com_soywiz_korge_korge.$_$.j1;
  var addTo = kotlin_com_soywiz_korge_korge.$_$.q1;
  var numberToDouble = kotlin_kotlin.$_$.pc;
  var Companion_getInstance_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.n3;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.o;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.x;
  var get_gamepad = kotlin_com_soywiz_korge_korge.$_$.x;
  var xy = kotlin_com_soywiz_korge_korge.$_$.w1;
  var get_hz = kotlin_com_soywiz_korge_korlibs_time.$_$.n;
  var addFixedUpdater = kotlin_com_soywiz_korge_korge.$_$.p1;
  var Key_SPACE_getInstance = kotlin_com_soywiz_korge_korge.$_$.g;
  var GameButton_BUTTON_SOUTH_getInstance = kotlin_com_soywiz_korge_korge.$_$.a;
  var Companion_getInstance_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.e3;
  var objectMeta = kotlin_kotlin.$_$.tc;
  var Companion_getInstance_2 = kotlin_com_soywiz_korge_korge_foundation.$_$.r3;
  var Key_LEFT_getInstance = kotlin_com_soywiz_korge_korge.$_$.e;
  var Key_RIGHT_getInstance = kotlin_com_soywiz_korge_korge.$_$.f;
  var Key_UP_getInstance = kotlin_com_soywiz_korge_korge.$_$.h;
  var Key_DOWN_getInstance = kotlin_com_soywiz_korge_korge.$_$.d;
  var Vector2D = kotlin_com_soywiz_korge_korge_foundation.$_$.x5;
  var Vector2D_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.x;
  var Size2D = kotlin_com_soywiz_korge_korge_foundation.$_$.v5;
  var Colors_getInstance = kotlin_com_soywiz_korge_korge_core.$_$.f1;
  var FastEllipse = kotlin_com_soywiz_korge_korge.$_$.k1;
  var colorMul = kotlin_com_soywiz_korge_korge.$_$.t1;
  var anchor = kotlin_com_soywiz_korge_korge.$_$.s1;
  var singleTouch = kotlin_com_soywiz_korge_korge.$_$.y;
  var Angle__cosine_impl_bgvzun = kotlin_com_soywiz_korge_korge_foundation.$_$.h1;
  var Angle__sine_impl_3l11xv = kotlin_com_soywiz_korge_korge_foundation.$_$.n1;
  var clamp01 = kotlin_com_soywiz_korge_korge_foundation.$_$.u6;
  var clamp = kotlin_com_soywiz_korge_korge_foundation.$_$.x6;
  var normalizeAlmostZero = kotlin_com_soywiz_korge_korge_foundation.$_$.t7;
  var Vector2D_init_$Create$_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.y;
  var interfaceMeta = kotlin_kotlin.$_$.wb;
  var KMutableProperty0 = kotlin_kotlin.$_$.rd;
  var getPropertyCallableRef = kotlin_kotlin.$_$.sb;
  //endregion
  //region block: pre-declaration
  setMetadataFor(ChangedEvent, 'ChangedEvent', classMeta, VOID, VOID, ChangedEvent);
  setMetadataFor(VirtualController, 'VirtualController', classMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  function computePos(rect) {
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var this_0 = rect.m2l(this.xbc());
    var that = this.odl();
    return new Vector2D(this_0.g28_1 + that.g28_1, this_0.h28_1 + that.h28_1);
  }
  setMetadataFor(VirtualConfig, 'VirtualConfig', interfaceMeta);
  setMetadataFor(VirtualButtonConfig, 'VirtualButtonConfig', classMeta, VOID, [VirtualConfig]);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(VirtualStickConfig, 'VirtualStickConfig', classMeta, VOID, [VirtualConfig]);
  setMetadataFor(VirtualStickView, 'VirtualStickView', classMeta, Container);
  setMetadataFor(VirtualButtonView, 'VirtualButtonView', classMeta, Container);
  setMetadataFor(KeyboardStickController, 'KeyboardStickController', classMeta);
  setMetadataFor(KeyboardButtonController, 'KeyboardButtonController', classMeta);
  //endregion
  function ChangedEvent(button, old, new_0) {
    button = button === VOID ? GameButton_LX_getInstance() : button;
    old = old === VOID ? 0.0 : old;
    new_0 = new_0 === VOID ? 0.0 : new_0;
    this.jdk_1 = button;
    this.kdk_1 = old;
    this.ldk_1 = new_0;
  }
  protoOf(ChangedEvent).mdk = function () {
    return !(this.kdk_1 === 0.0);
  };
  protoOf(ChangedEvent).ndk = function () {
    return !(this.ldk_1 === 0.0);
  };
  protoOf(ChangedEvent).toString = function () {
    return 'ChangedEvent(button=' + this.jdk_1 + ', old=' + this.kdk_1 + ', new=' + this.ldk_1 + ')';
  };
  protoOf(ChangedEvent).hashCode = function () {
    var result = this.jdk_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.kdk_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ldk_1) | 0;
    return result;
  };
  protoOf(ChangedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ChangedEvent ? other : THROW_CCE();
    if (!this.jdk_1.equals(tmp0_other_with_cast.jdk_1))
      return false;
    if (!equals(this.kdk_1, tmp0_other_with_cast.kdk_1))
      return false;
    if (!equals(this.ldk_1, tmp0_other_with_cast.ldk_1))
      return false;
    return true;
  };
  function VirtualController$changed$lambda($button, $block) {
    return function (it) {
      if (it.jdk_1.equals($button))
        $block(it);
      return Unit_instance;
    };
  }
  function VirtualController$down$lambda($block) {
    return function (it) {
      if (!it.mdk() ? it.ndk() : false)
        $block();
      return Unit_instance;
    };
  }
  function VirtualController(container) {
    this.odk_1 = container;
    this.pdk_1 = new GamepadInfo();
    this.qdk_1 = new GamepadInfo();
    this.rdk_1 = new ChangedEvent();
    this.sdk_1 = new Signal();
  }
  protoOf(VirtualController).tdk = function () {
    return this.d7s(GameButton_LX_getInstance());
  };
  protoOf(VirtualController).udk = function () {
    return this.d7s(GameButton_LY_getInstance());
  };
  protoOf(VirtualController).d7s = function (button) {
    return this.qdk_1.r7r_1[button.g7s()];
  };
  protoOf(VirtualController).vdk = function (button, value) {
    this.qdk_1.r7r_1[button.g7s()] = value;
  };
  protoOf(VirtualController).wdk = function (button, block) {
    return this.sdk_1.q5n(VirtualController$changed$lambda(button, block));
  };
  protoOf(VirtualController).xdk = function (button, block) {
    return this.wdk(button, VirtualController$down$lambda(block));
  };
  protoOf(VirtualController).ydk = function () {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = Companion_getInstance().v7s_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.virtualcontroller.VirtualController.updated.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = this_0[tmp0];
      var old = this.pdk_1.d7s(it);
      var new_0 = this.qdk_1.d7s(it);
      if (!(old === new_0)) {
        this.rdk_1.jdk_1 = it;
        this.rdk_1.kdk_1 = old;
        this.rdk_1.ldk_1 = new_0;
        this.sdk_1.x5n(this.rdk_1);
      }
    }
    this.pdk_1.v7r(this.qdk_1);
  };
  function virtualController(_this__u8e3s4, sticks, buttons, buttonRadius, boundsRadiusScale) {
    sticks = sticks === VOID ? listOf(Companion_getInstance_4().zdk_1) : sticks;
    buttons = buttons === VOID ? listOf(Companion_getInstance_3().adl_1) : buttons;
    buttonRadius = buttonRadius === VOID ? 92 : buttonRadius;
    boundsRadiusScale = boundsRadiusScale === VOID ? 1.25 : boundsRadiusScale;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = new Container(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    var container = addTo(this_0, _this__u8e3s4);
    var controller = new VirtualController(container);
    var boundsRadiusScaled = numberToDouble(buttonRadius) * numberToDouble(boundsRadiusScale);
    var rect = Companion_getInstance_0().t2k(boundsRadiusScaled, boundsRadiusScaled, _this__u8e3s4.x1q() - boundsRadiusScaled, _this__u8e3s4.y1q() - boundsRadiusScaled);
    // Inline function 'kotlin.collections.arrayListOf' call
    var virtualStickViews = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.arrayListOf' call
    var virtualButtonViews = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.arrayListOf' call
    var keyStickControllers = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.arrayListOf' call
    var keyButtonControllers = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var stickByButton = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var buttonByButton = LinkedHashMap_init_$Create$();
    // Inline function 'korlibs.korge.input.gamepad' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var $this$gamepad = get_gamepad(_this__u8e3s4);
    var lastGamepadInfo = new GamepadInfo();
    $this$gamepad.ga1(virtualController$lambda(lastGamepadInfo, stickByButton, buttonByButton));
    var tmp0_iterator = sticks.u();
    while (tmp0_iterator.v()) {
      var stick = tmp0_iterator.x();
      var virtualStickView = xy(new VirtualStickView(controller, stick, numberToDouble(buttonRadius)), stick.bdl(rect));
      // Inline function 'kotlin.collections.set' call
      var key = stick.gdl_1;
      stickByButton.i2(key, virtualStickView);
      // Inline function 'kotlin.collections.set' call
      var key_0 = stick.hdl_1;
      stickByButton.i2(key_0, virtualStickView);
      // Inline function 'kotlin.collections.plusAssign' call
      virtualStickViews.r(virtualStickView);
      container.pag(virtualStickView);
      // Inline function 'kotlin.collections.plusAssign' call
      var element = new KeyboardStickController(stick, virtualStickView);
      keyStickControllers.r(element);
    }
    var tmp1_iterator = buttons.u();
    while (tmp1_iterator.v()) {
      var button = tmp1_iterator.x();
      var virtualButtonView = xy(new VirtualButtonView(controller, button, numberToDouble(buttonRadius)), button.bdl(rect));
      // Inline function 'kotlin.collections.plusAssign' call
      virtualButtonViews.r(virtualButtonView);
      container.pag(virtualButtonView);
      // Inline function 'kotlin.collections.set' call
      var key_1 = button.ldl_1;
      buttonByButton.i2(key_1, virtualButtonView);
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = new KeyboardButtonController(button, virtualButtonView);
      keyButtonControllers.r(element_0);
    }
    var tmp = get_hz(60);
    addFixedUpdater(_this__u8e3s4, tmp, VOID, VOID, virtualController$lambda_0(boundsRadiusScaled, keyStickControllers, controller, keyButtonControllers, virtualStickViews, virtualButtonViews));
    return controller;
  }
  function Companion() {
    Companion_instance = this;
    this.adl_1 = new VirtualButtonConfig(Key_SPACE_getInstance(), GameButton_BUTTON_SOUTH_getInstance(), Companion_getInstance_1().n2c_1);
  }
  var Companion_instance;
  function Companion_getInstance_3() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function VirtualButtonConfig(key, button, anchor, offset) {
    Companion_getInstance_3();
    offset = offset === VOID ? Companion_getInstance_2().d2d_1 : offset;
    this.kdl_1 = key;
    this.ldl_1 = button;
    this.mdl_1 = anchor;
    this.ndl_1 = offset;
  }
  protoOf(VirtualButtonConfig).xbc = function () {
    return this.mdl_1;
  };
  protoOf(VirtualButtonConfig).odl = function () {
    return this.ndl_1;
  };
  protoOf(VirtualButtonConfig).toString = function () {
    return 'VirtualButtonConfig(key=' + this.kdl_1 + ', button=' + this.ldl_1 + ', anchor=' + this.mdl_1 + ', offset=' + this.ndl_1 + ')';
  };
  protoOf(VirtualButtonConfig).hashCode = function () {
    var result = this.kdl_1.hashCode();
    result = imul(result, 31) + this.ldl_1.hashCode() | 0;
    result = imul(result, 31) + this.mdl_1.hashCode() | 0;
    result = imul(result, 31) + this.ndl_1.hashCode() | 0;
    return result;
  };
  protoOf(VirtualButtonConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VirtualButtonConfig))
      return false;
    var tmp0_other_with_cast = other instanceof VirtualButtonConfig ? other : THROW_CCE();
    if (!this.kdl_1.equals(tmp0_other_with_cast.kdl_1))
      return false;
    if (!this.ldl_1.equals(tmp0_other_with_cast.ldl_1))
      return false;
    if (!this.mdl_1.equals(tmp0_other_with_cast.mdl_1))
      return false;
    if (!this.ndl_1.equals(tmp0_other_with_cast.ndl_1))
      return false;
    return true;
  };
  function Companion_0() {
    Companion_instance_0 = this;
    this.zdk_1 = new VirtualStickConfig(Key_LEFT_getInstance(), Key_RIGHT_getInstance(), Key_UP_getInstance(), Key_DOWN_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), Companion_getInstance_1().l2c_1);
  }
  var Companion_instance_0;
  function Companion_getInstance_4() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function VirtualStickConfig(left, right, up, down, lx, ly, anchor, offset) {
    Companion_getInstance_4();
    offset = offset === VOID ? Companion_getInstance_2().d2d_1 : offset;
    this.cdl_1 = left;
    this.ddl_1 = right;
    this.edl_1 = up;
    this.fdl_1 = down;
    this.gdl_1 = lx;
    this.hdl_1 = ly;
    this.idl_1 = anchor;
    this.jdl_1 = offset;
  }
  protoOf(VirtualStickConfig).xbc = function () {
    return this.idl_1;
  };
  protoOf(VirtualStickConfig).odl = function () {
    return this.jdl_1;
  };
  protoOf(VirtualStickConfig).toString = function () {
    return 'VirtualStickConfig(left=' + this.cdl_1 + ', right=' + this.ddl_1 + ', up=' + this.edl_1 + ', down=' + this.fdl_1 + ', lx=' + this.gdl_1 + ', ly=' + this.hdl_1 + ', anchor=' + this.idl_1 + ', offset=' + this.jdl_1 + ')';
  };
  protoOf(VirtualStickConfig).hashCode = function () {
    var result = this.cdl_1.hashCode();
    result = imul(result, 31) + this.ddl_1.hashCode() | 0;
    result = imul(result, 31) + this.edl_1.hashCode() | 0;
    result = imul(result, 31) + this.fdl_1.hashCode() | 0;
    result = imul(result, 31) + this.gdl_1.hashCode() | 0;
    result = imul(result, 31) + this.hdl_1.hashCode() | 0;
    result = imul(result, 31) + this.idl_1.hashCode() | 0;
    result = imul(result, 31) + this.jdl_1.hashCode() | 0;
    return result;
  };
  protoOf(VirtualStickConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VirtualStickConfig))
      return false;
    var tmp0_other_with_cast = other instanceof VirtualStickConfig ? other : THROW_CCE();
    if (!this.cdl_1.equals(tmp0_other_with_cast.cdl_1))
      return false;
    if (!this.ddl_1.equals(tmp0_other_with_cast.ddl_1))
      return false;
    if (!this.edl_1.equals(tmp0_other_with_cast.edl_1))
      return false;
    if (!this.fdl_1.equals(tmp0_other_with_cast.fdl_1))
      return false;
    if (!this.gdl_1.equals(tmp0_other_with_cast.gdl_1))
      return false;
    if (!this.hdl_1.equals(tmp0_other_with_cast.hdl_1))
      return false;
    if (!this.idl_1.equals(tmp0_other_with_cast.idl_1))
      return false;
    if (!this.jdl_1.equals(tmp0_other_with_cast.jdl_1))
      return false;
    return true;
  };
  function VirtualStickView$lambda$lambda(it) {
    return Unit_instance;
  }
  function VirtualStickView$lambda$lambda_0(this$0) {
    return function (it) {
      // Inline function 'korlibs.math.geom.Vector2D.minus' call
      var this_0 = it.ka3_1;
      var that = it.la3_1;
      var tmp$ret$0 = new Vector2D(this_0.g28_1 - that.g28_1, this_0.h28_1 - that.h28_1);
      this$0.bdo(tmp$ret$0);
      return Unit_instance;
    };
  }
  function VirtualStickView$lambda$lambda_1(this$0) {
    return function (it) {
      this$0.bdo(Vector2D_init_$Create$(0, 0));
      return Unit_instance;
    };
  }
  function VirtualStickView$lambda(this$0) {
    return function ($this$singleTouch, it) {
      $this$singleTouch.ja4_1.w5n(VirtualStickView$lambda$lambda);
      $this$singleTouch.ma4_1.w5n(VirtualStickView$lambda$lambda_0(this$0));
      $this$singleTouch.oa4_1.w5n(VirtualStickView$lambda$lambda_1(this$0));
      return Unit_instance;
    };
  }
  function VirtualStickView(controller, config, radius) {
    radius = radius === VOID ? 64.0 : radius;
    Container.call(this);
    this.xdn_1 = controller;
    this.ydn_1 = config;
    var tmp = this;
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.korge.view.fastEllipse' call
    var size = new Size2D(radius * 1.5, radius * 1.5);
    var color = Colors_getInstance().l3b_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = colorMul(new FastEllipse(size), color);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.fastEllipse.<anonymous>' call
    var this_2 = anchor(this_1, Companion_getInstance_1().o2c());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.virtualcontroller.VirtualStickView.circleOut.<anonymous>' call
    this_2.aby(0.5);
    tmp.zdn_1 = this_2;
    var tmp_0 = this;
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.korge.view.fastEllipse' call
    var size_0 = new Size2D(radius, radius);
    var color_0 = Colors_getInstance().l3b_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_3 = colorMul(new FastEllipse(size_0), color_0);
    // Inline function 'kotlin.apply' call
    var this_4 = addTo(this_3, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.fastEllipse.<anonymous>' call
    var this_5 = anchor(this_4, Companion_getInstance_1().o2c());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.virtualcontroller.VirtualStickView.circle.<anonymous>' call
    this_5.aby(0.75);
    tmp_0.ado_1 = this_5;
    singleTouch(this, VOID, VOID, VirtualStickView$lambda(this));
  }
  protoOf(VirtualStickView).cbt = function () {
    return this.ado_1.cbt().r2k_1;
  };
  protoOf(VirtualStickView).cdo = function (pos) {
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = this.cbt();
    var tmp$ret$0 = new Vector2D(pos.g28_1 * scale, pos.h28_1 * scale);
    this.bdo(tmp$ret$0);
  };
  protoOf(VirtualStickView).bdo = function (pos) {
    // Inline function 'korlibs.math.geom.Companion.polar' call
    var this_0 = Companion_getInstance_2();
    var angle = pos.h2n();
    // Inline function 'korlibs.math.geom.Companion.polar' call
    var up = this_0.h2d_1;
    var polar = new Vector2D(0.0 + Angle__cosine_impl_bgvzun(angle, up) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angle, up) * 1.0);
    var magnitudeScale = clamp01(pos.n2n() / this.cbt());
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scaledPolar = new Vector2D(polar.g28_1 * magnitudeScale, polar.h28_1 * magnitudeScale);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = this.cbt();
    var tmp$ret$3 = new Vector2D(scaledPolar.g28_1 * scale, scaledPolar.h28_1 * scale);
    this.ado_1.u46(tmp$ret$3);
    this.xdn_1.vdk(this.ydn_1.gdl_1, scaledPolar.g28_1);
    this.xdn_1.vdk(this.ydn_1.hdl_1, scaledPolar.h28_1);
  };
  function VirtualButtonView$lambda$lambda(this$0) {
    return function (it) {
      this$0.pdq(true);
      return Unit_instance;
    };
  }
  function VirtualButtonView$lambda$lambda_0(this$0) {
    return function (it) {
      this$0.pdq(false);
      return Unit_instance;
    };
  }
  function VirtualButtonView$lambda(this$0) {
    return function ($this$singleTouch, it) {
      $this$singleTouch.ja4_1.w5n(VirtualButtonView$lambda$lambda(this$0));
      $this$singleTouch.oa4_1.w5n(VirtualButtonView$lambda$lambda_0(this$0));
      return Unit_instance;
    };
  }
  function VirtualButtonView(controller, config, radius) {
    radius = radius === VOID ? 64.0 : radius;
    Container.call(this);
    this.ldq_1 = controller;
    this.mdq_1 = config;
    var tmp = this;
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.korge.view.fastEllipse' call
    var size = new Size2D(radius, radius);
    var color = Colors_getInstance().l3b_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = colorMul(new FastEllipse(size), color);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.fastEllipse.<anonymous>' call
    var this_2 = anchor(this_1, Companion_getInstance_1().o2c());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.virtualcontroller.VirtualButtonView.circle.<anonymous>' call
    this_2.aby(0.8);
    tmp.ndq_1 = this_2;
    this.odq_1 = radiusAvg$factory(this.ndq_1);
    singleTouch(this, VOID, VOID, VirtualButtonView$lambda(this));
  }
  protoOf(VirtualButtonView).pdq = function (pressed) {
    // Inline function 'korlibs.math.toInt' call
    var tmp$ret$0 = pressed ? 1 : 0;
    this.ldq_1.vdk(this.mdq_1.ldl_1, tmp$ret$0);
    this.ndq_1.aby(pressed ? 1.0 : 0.8);
  };
  function KeyboardStickController(config, virtualStickView) {
    this.qdq_1 = config;
    this.rdq_1 = virtualStickView;
    this.sdq_1 = 0.0;
    this.tdq_1 = 0.0;
    this.udq_1 = false;
  }
  protoOf(KeyboardStickController).vdq = function (view, controller) {
    var tmp1_safe_receiver = view == null ? null : view.bax();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.cca();
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.l9p_1;
    var tmp;
    if (tmp3_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp3_elvis_lhs;
    }
    var keys = tmp;
    var keyPressed = ((keys.na1(this.qdq_1.cdl_1) ? true : keys.na1(this.qdq_1.ddl_1)) ? true : keys.na1(this.qdq_1.edl_1)) ? true : keys.na1(this.qdq_1.fdl_1);
    if (keyPressed) {
      this.udq_1 = true;
    }
    if (keys.na1(this.qdq_1.cdl_1)) {
      this.sdq_1 = this.sdq_1 - 0.125;
    } else if (keys.na1(this.qdq_1.ddl_1)) {
      this.sdq_1 = this.sdq_1 + 0.125;
    } else {
      this.sdq_1 = this.sdq_1 / 2.0;
    }
    if (keys.na1(this.qdq_1.edl_1)) {
      this.tdq_1 = this.tdq_1 - 0.125;
    } else if (keys.na1(this.qdq_1.fdl_1)) {
      this.tdq_1 = this.tdq_1 + 0.125;
    } else {
      this.tdq_1 = this.tdq_1 / 2.0;
    }
    this.sdq_1 = normalizeAlmostZero(clamp(this.sdq_1, -1.0, 1.0));
    this.tdq_1 = normalizeAlmostZero(clamp(this.tdq_1, -1.0, 1.0));
    if (this.udq_1) {
      controller.vdk(this.qdq_1.gdl_1, this.sdq_1);
      controller.vdk(this.qdq_1.hdl_1, this.tdq_1);
      var tmp10_safe_receiver = this.rdq_1;
      if (tmp10_safe_receiver == null)
        null;
      else {
        tmp10_safe_receiver.cdo(Vector2D_init_$Create$_0(this.sdq_1, this.tdq_1));
      }
    }
    if (((this.udq_1 ? this.sdq_1 === 0.0 : false) ? this.tdq_1 === 0.0 : false) ? !keyPressed : false) {
      this.udq_1 = false;
    }
  };
  function KeyboardButtonController(config, virtualButtonView) {
    this.wdq_1 = config;
    this.xdq_1 = virtualButtonView;
    this.ydq_1 = false;
  }
  protoOf(KeyboardButtonController).vdq = function (view, controller) {
    var tmp0_safe_receiver = view.bax();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cca();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l9p_1;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var keys = tmp;
    var keyPressed = keys.na1(this.wdq_1.kdl_1);
    if (keyPressed) {
      this.ydq_1 = true;
    }
    if (this.ydq_1) {
      // Inline function 'korlibs.math.toInt' call
      var tmp$ret$0 = keyPressed ? 1 : 0;
      controller.vdk(this.wdq_1.ldl_1, tmp$ret$0);
      var tmp3_safe_receiver = this.xdq_1;
      if (tmp3_safe_receiver == null)
        null;
      else {
        tmp3_safe_receiver.pdq(keyPressed);
      }
    }
    if (!keyPressed) {
      this.ydq_1 = false;
    }
  };
  function VirtualConfig() {
  }
  function virtualController$lambda($lastGamepadInfo, $stickByButton, $buttonByButton) {
    return function (it) {
      var indexedObject = Companion_getInstance().v7s_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var button = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (!(it.d7s(button) === $lastGamepadInfo.d7s(button))) {
          var tmp1_safe_receiver = $stickByButton.s2(button);
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            tmp1_safe_receiver.cdo(Vector2D_init_$Create$_0(it.d7s(tmp1_safe_receiver.ydn_1.gdl_1), -it.d7s(tmp1_safe_receiver.ydn_1.hdl_1)));
          }
          var tmp2_safe_receiver = $buttonByButton.s2(button);
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.pdq(!(it.d7s(button) === 0.0));
          }
        }
      }
      $lastGamepadInfo.v7r(it);
      return Unit_instance;
    };
  }
  function virtualController$lambda_0($boundsRadiusScaled, $keyStickControllers, $controller, $keyButtonControllers, $virtualStickViews, $virtualButtonViews) {
    return function ($this$addFixedUpdater) {
      var rect = Companion_getInstance_0().t2k($boundsRadiusScaled, $boundsRadiusScaled, $this$addFixedUpdater.x1q() - $boundsRadiusScaled, $this$addFixedUpdater.y1q() - $boundsRadiusScaled);
      var this_0 = $keyStickControllers;
      var n = 0;
      while (n < this_0.n()) {
        // Inline function 'korlibs.korge.virtualcontroller.virtualController.<anonymous>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        this_0.f1(tmp0).vdq($this$addFixedUpdater, $controller);
      }
      var this_1 = $keyButtonControllers;
      var n_0 = 0;
      while (n_0 < this_1.n()) {
        // Inline function 'korlibs.korge.virtualcontroller.virtualController.<anonymous>.<anonymous>' call
        var tmp0_0 = n_0;
        n_0 = tmp0_0 + 1 | 0;
        this_1.f1(tmp0_0).vdq($this$addFixedUpdater, $controller);
      }
      $controller.ydk();
      var this_2 = $virtualStickViews;
      var n_1 = 0;
      while (n_1 < this_2.n()) {
        // Inline function 'korlibs.korge.virtualcontroller.virtualController.<anonymous>.<anonymous>' call
        var tmp0_1 = n_1;
        n_1 = tmp0_1 + 1 | 0;
        var it = this_2.f1(tmp0_1);
        it.u46(it.ydn_1.bdl(rect));
      }
      var this_3 = $virtualButtonViews;
      var n_2 = 0;
      while (n_2 < this_3.n()) {
        // Inline function 'korlibs.korge.virtualcontroller.virtualController.<anonymous>.<anonymous>' call
        var tmp0_2 = n_2;
        n_2 = tmp0_2 + 1 | 0;
        var it_0 = this_3.f1(tmp0_2);
        it_0.u46(it_0.mdq_1.bdl(rect));
      }
      return Unit_instance;
    };
  }
  function radiusAvg$factory($b0) {
    return getPropertyCallableRef('radiusAvg', 0, KMutableProperty0, function () {
      return $b0.ebt();
    }, function (value) {
      return $b0.dbt(value);
    });
  }
  //region block: post-declaration
  protoOf(VirtualButtonConfig).bdl = computePos;
  protoOf(VirtualStickConfig).bdl = computePos;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance_3;
  _.$_$.b = virtualController;
  //endregion
  return _;
}));
